import AppStoreBadge from '../assets/icons/app-store-badge.svg';
import PlayStoreBadge from '../assets/images/google-play-badge.png';
import Background from '../assets/images/signin_background_image.png';
export const Images = {
  Background,
  PlayStoreBadge,
  AppStoreBadge,
};
